import React from 'react';
import { navigate, Link } from 'gatsby';
import styled from 'styled-components';
import { useEffect } from 'react';
import { useState } from 'react';

import { changePlayerInfo, changePodcastInfo } from '../../slices/AppSlice';
import { useAppDispatch } from '../../types/hooks';
import { Post } from '../../types/types';
import PodcastsIcon from '../../images/podcast-negro.svg';
import PlayIcon from '../../images/play-negro.svg';
import ReadIcon from '../../images/leer.svg';
import { PROGRAMAS_MAP } from '../../utils/constants';
import { getMainCategorySlug } from '../../utils/utilities';

const StyledSidebarPodcastsContainer = styled.div`
  margin-top: 2rem;
  cursor: pointer;
  .noticias-header {
    display: flex;
    margin-bottom: 1rem;
    text-transform: uppercase;
    font-family: 'TradeGothic Gold20';
    align-items: center;
    font-size: 1.4rem;
    img {
      width: 1.5rem;
      height: 1.5rem;
      margin-right: 0.5rem;
      position: relative;
      top: -0.2rem;
    }
  }
  .podcast-items-container {
    margin: 0.75rem 0;
    border-bottom: 1px solid var(--border-gray);
    padding-bottom: 0.5rem;
    &:last-child {
      border-bottom: none;
    }
    .podcast-tag {
      color: var(--verde-principal);
      text-transform: uppercase;
      font-size: 0.85rem;
      font-family: 'TradeGothicN2';
    }
    .podcast-info {
      font-family: 'TradeGothic Gold18';
      font-size: 1.2rem;
      display: flex;
      justify-content: space-between;
      a {
        font-size: 0.9rem;
        font-family: 'TradeGothicN2';
        @media (min-width: 576px) {
          font-size: 1.05rem;
        }
      }
      img {
        margin-left: 1rem;
        width: 2rem;
        height: 2rem;
      }
    }
  }
`;

type SidebarPodcastsProps = {
  podcastPosts: Post[];
  postId: string;
  mainCategorySlug: string;
};

const SidebarPodcasts = ({ podcastPosts, postId, mainCategorySlug }: SidebarPodcastsProps) => {
  const dispatch = useAppDispatch();
  const [displayedPodcastPosts, setDisplayedPodcastPosts] = useState<Post[]>([]);

  useEffect(() => {
    const tmpDisplayedPodcastPosts: Post[] = [];

    podcastPosts.forEach((post: Post) => {
      if (tmpDisplayedPodcastPosts.length < 5 && post.id !== postId) {
        tmpDisplayedPodcastPosts.push(post);
      }
    });
    setDisplayedPodcastPosts(tmpDisplayedPodcastPosts);
  }, []);

  const goToPost = (selectedPost: Post, playAudio: boolean) => {
    if (playAudio && selectedPost.afc_post.audioDeLaNota) {
      dispatch(
        changePlayerInfo({
          playerUrl: selectedPost.afc_post.audioDeLaNota.mediaItemUrl,
          playerSlug: mainCategorySlug,
          timeStamp: new Date().getUTCMilliseconds(),
        }),
      );
      dispatch(
        changePodcastInfo({
          podcastTitle: selectedPost.title,
          podcastSlug: selectedPost.slug,
        }),
      );
    }
    navigate(`/${selectedPost.slug}`);
  };

  return (
    <StyledSidebarPodcastsContainer>
      <div className="noticias-header">
        <img alt="Icono de últimos podcast" src={PodcastsIcon} />
        <h3>Últimos Programas</h3>
      </div>
      <div className="post-noticias">
        {displayedPodcastPosts.length > 0 &&
          displayedPodcastPosts.map((podcastPost: Post) => (
            <div key={podcastPost.id} className="podcast-items-container">
              {podcastPost.categories && podcastPost.categories.nodes.length > 0 && (
                <p className="podcast-tag">
                  {PROGRAMAS_MAP[getMainCategorySlug(podcastPost.categories.nodes)]?.title}
                </p>
              )}
              <div className="podcast-info">
                <a href="#" onClick={() => goToPost(podcastPost, false)}>
                  {podcastPost.title}
                </a>
                {podcastPost.afc_post.audioDeLaNota ? (
                  <button className="play-button" onClick={() => goToPost(podcastPost, true)}>
                    <img alt="Icono de reproducir el podcast" src={PlayIcon} />
                  </button>
                ) : (
                  <Link className="read-button" to={`/${podcastPost.slug}`}>
                    <img alt="Icono de leer la nota" src={ReadIcon} />
                  </Link>
                )}
              </div>
            </div>
          ))}
      </div>
    </StyledSidebarPodcastsContainer>
  );
};

export default SidebarPodcasts;
